import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../forum/app';
import PaginatedListState from '../../common/states/PaginatedListState';
import EventEmitter from '../../common/utils/EventEmitter';
const globalEventEmitter = new EventEmitter();
export default class DiscussionListState extends PaginatedListState {
  constructor(params, page) {
    if (page === void 0) {
      page = 1;
    }
    super(params, page, null);
    _defineProperty(this, "extraDiscussions", []);
    _defineProperty(this, "eventEmitter", void 0);
    this.eventEmitter = globalEventEmitter.on('discussion.deleted', this.deleteDiscussion.bind(this));
  }
  get type() {
    return 'discussions';
  }
  requestParams() {
    const params = {
      include: ['user', 'lastPostedUser'],
      filter: this.params.filter || {},
      sort: this.currentSort()
    };
    if (this.params.q) {
      params.filter.q = this.params.q;
      params.include.push('mostRelevantPost', 'mostRelevantPost.user');
    }
    return params;
  }
  loadPage(page) {
    if (page === void 0) {
      page = 1;
    }
    const preloadedDiscussions = app.preloadedApiDocument();
    if (preloadedDiscussions) {
      this.initialLoading = false;
      this.pageSize = preloadedDiscussions.payload.meta?.perPage || DiscussionListState.DEFAULT_PAGE_SIZE;
      return Promise.resolve(preloadedDiscussions);
    }
    return super.loadPage(page);
  }
  clear() {
    super.clear();
    this.extraDiscussions = [];
  }

  /**
   * Get a map of sort keys (which appear in the URL, and are used for
   * translation) to the API sort value that they represent.
   */
  sortMap() {
    const map = {};
    if (this.params.q) {
      map.relevance = '';
    }
    map.latest = '-lastPostedAt';
    map.top = '-commentCount';
    map.newest = '-createdAt';
    map.oldest = 'createdAt';
    return map;
  }
  removeDiscussion(discussion) {
    this.eventEmitter.emit('discussion.deleted', discussion);
  }
  deleteDiscussion(discussion) {
    for (const page of this.pages) {
      const index = page.items.indexOf(discussion);
      if (index !== -1) {
        page.items.splice(index, 1);
        break;
      }
    }
    const index = this.extraDiscussions.indexOf(discussion);
    if (index !== -1) {
      this.extraDiscussions.splice(index);
    }
    m.redraw();
  }

  /**
   * Add a discussion to the top of the list.
   */
  addDiscussion(discussion) {
    this.removeDiscussion(discussion);
    this.extraDiscussions.unshift(discussion);
    m.redraw();
  }
  getAllItems() {
    return this.extraDiscussions.concat(super.getAllItems());
  }
  getPages() {
    const pages = super.getPages();
    if (this.extraDiscussions.length) {
      return [{
        number: -1,
        items: this.extraDiscussions
      }, ...pages];
    }
    return pages;
  }
}
flarum.reg.add('core', 'forum/states/DiscussionListState', DiscussionListState);